import { Fragment, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
// includes
import { api, common, config } from "helpers";
import StatusBar from "elements/statusBar";

function View() {
  const { id } = useParams();
  const navigate = useNavigate();
  const htmlParse = require("html-react-parser");
  // state
  const [status, setStatus] = useState("process");
  const [result, setResult] = useState(null);

  // effect
  useEffect(() => {
    getInfo();
  }, []);

  // api
  const getInfo = () => {
    let data = {
      url: "careerContent",
      method: "GET",
      query: `/${id}`,
    };

    api.call(data, (res) => {
      if (res.status === 200) {
        setResult(res.data);
        setStatus("success");
      } else {
        setStatus("error");
      }
    });
  };

  return (
    <Fragment>
      <div className="title-wrap d-flex align-items-center">
        <img
          src={common.loadImg("back-icn.svg")}
          className="ed-cp"
          alt=""
          onClick={() => navigate(-1)}
        />
        <h1 className="page-title ps-4">Job Detail</h1>
      </div>
      <div className="content-wrap">
        <div className="inner-content-wrap">
          {status !== "success" ? (
            <StatusBar status={status} />
          ) : (
            <Fragment>
              <div className="et-view-content-wrap">
                {/* Inner Content */}
                <div className="et-vc-info et-view-border-bottom">
                  <ul className="et-vc-list row">
                    <li className="p-0">
                      <h2 className="form-title-step3">Info</h2>
                    </li>
                    <li className="col-md-4 et-view-border-bottom et-view-border-right">
                      <div className="et-list-inner">
                        <p className="et-field-name">Title</p>
                        <p className="et-field-value">
                          {result?.title ? result?.title : "-"}
                        </p>
                      </div>
                    </li>
                    <li className="col-md-4 et-view-border-bottom et-view-border-right">
                      <div className="et-list-inner">
                        <p className="et-field-name">Country</p>
                        <p className="et-field-value">
                          {result?.countryId ? result?.countryId : "-"}
                        </p>
                      </div>
                    </li>
                    <li className="col-md-4 et-view-border-bottom et-view-border-right">
                      <div className="et-list-inner">
                        <p className="et-field-name">Category</p>
                        <p className="et-field-value">
                          {result?.categoryId ? result?.categoryId?.name : "-"}
                        </p>
                      </div>
                    </li>
                    <li className="col-md-4 et-view-border-bottom et-view-border-right">
                      <div className="et-list-inner">
                        <p className="et-field-name">Job Skills</p>
                        {result?.skills.map((item, i) => (
                          <p className="et-field-value" key={i}>
                            {item}
                          </p>
                        ))}
                      </div>
                    </li>
                    <li className="col-md-4 et-view-border-bottom et-view-border-right">
                      <div className="et-list-inner">
                        <p className="et-field-name">Job Link</p>
                        <Link
                          to={result?.url ? result?.url : "#"}
                          target="_blank"
                          className="et-field-value"
                        >
                          {result?.url ? result?.url : ""}
                        </Link>
                      </div>
                    </li>
                    <li className="col-md-4 et-view-border-bottom et-view-border-right">
                      <div className="et-list-inner">
                        <p className="et-field-name">Active</p>
                        <p className="et-field-value">
                          {result?.isActive ? "Yes" : "No"}
                        </p>
                      </div>
                    </li>
                    <li className="col-md-4 et-view-border-bottom et-view-border-right"></li>
                    <li className="px-0">
                      <h2 className="form-title-step3">Description</h2>
                    </li>
                    <li className="px-0">
                      <div className="row-wrap-step3 editor-content-wrap et-view-border-bottom">
                        {result?.description
                          ? htmlParse(result.description)
                          : "-"}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>
  );
}
export default View;
